// extracted by mini-css-extract-plugin
export default {"stealDealSuccessInfo":"rDGl1N"};